import type { WithStyles } from '@material-ui/core'
import { createStyles, withStyles } from '@material-ui/core'
import type { User } from '@paintscout/api'
import { getHighestRoleName } from '@paintscout/util/users'
import React from 'react'
import Tile from '@paintscout/ui/components/Tile'
import Typography from '@paintscout/ui/components/Typography'
import type { TileProps } from '@paintscout/ui/components/Tile'

export interface UserTileProps extends WithStyles<typeof styles>, Omit<TileProps, 'classes'> {
  user: User
}

const styles = () =>
  createStyles({
    root: {}
  })

function UserTile({ user, ...props }: UserTileProps) {
  return (
    <Tile {...props}>
      <div>{user.name}</div>
      <Typography variant="subtitle1">{getRoleName(user)}</Typography>
    </Tile>
  )
}

export function getRoleName(user: User) {
  const roles = user?.app_metadata?.roles ?? []
  return getHighestRoleName(roles)
}

export default withStyles(styles)(UserTile)
